export default __webpack_public_path__ + "static/media/BeVietnam-Medium.6f4ce9c2.ttf";